import { MdClose } from "react-icons/md"
import AccommodationMenuList from "../campusLife/accommodationMenuList"
import Contents from "../campusLife/tabContents"
import { motion } from 'framer-motion';
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { fetchAboutUnitenContentData } from "../../redux/slice/aboutUnitenContentPage";

const SideMenu = ({ list, contents, children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const defaultActiveTab = parseInt(queryParams.get('sideTab')) || 0;

    const [activeTab, setActiveTab] = useState(defaultActiveTab);

    const handleTabClick = (index) => {
        
        setActiveTab(index);
        queryParams.set('sideTab', index);
        navigate({ search: queryParams.toString() });
    };


    const dispatch = useDispatch()
    const state = useSelector(state => state.aboutUniten)


    useEffect(() => {
        if (state?.data?.properties?.content != null) {

            dispatch(fetchAboutUnitenContentData(state?.data?.properties?.content[activeTab]?.route?.path))
        }

    }, [state, activeTab, dispatch])

    useEffect(() => {
        const activeTabFromQuery = parseInt(queryParams.get('sideTab')) || 0;
        setActiveTab(activeTabFromQuery);
    }, [queryParams]);

    const [open, setOpen] = useState(false)

    if (typeof window !== 'undefined') {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }

    return (
        <div className="grid grid-cols-1 lg:grid-cols-[30%_70%] gap-16">
            <div className="flex justify-start lg:hidden">
                <button  onClick={() => setOpen(!open)} className="px-8 py-4 w-fit rounded border border-blue-700 text-blue-700 justify-center items-center gap-4 flex">
                    <span className="text-base whitespace-nowrap font-bold capitalize flex items-center gap-3">{open ? "Close" : "Open"} Menu</span>
                </button>
            </div>
            {
                open &&
                <motion.div
                    initial={{ x: " -100%" }}
                    animate={{ x: open ? 0 : "-100%" }}
                    transition={{ duration: 0.5 }}
                    className="lg:hidden flex fixed overflow-y-auto scroll-bar py-10 p-4 bg-white bg-opacity-60 backdrop-blur-md inset-0 z-50 flex-col  w-full">
                    <div className="lg:hidden flex flex-col gap-6">

                        <div className="flex justify-end">
                            <button onClick={() => setOpen(!open)} className=" w-8 h-8 rounded-full border border-blue-700 text-blue-700 justify-center items-center gap-4 flex">
                                <MdClose />
                            </button>
                        </div>
                        <AccommodationMenuList items={list} activeTab={activeTab} handleTabClick={handleTabClick} />
                        {
                            children
                        }
                    </div>
                </motion.div>
            }
            <div className="hidden lg:flex flex-col gap-6 w-full">
                <AccommodationMenuList items={list} activeTab={activeTab} handleTabClick={handleTabClick} />
                {
                    children
                }
            </div>
            <Contents contents={contents} activeTab={activeTab} />

        </div>
    )
}
SideMenu.propTypes = {
    list: PropTypes.array,
    contents: PropTypes.array,
    children: PropTypes.node
}
export default SideMenu